import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import apolloClient from 'api/apolloClient';
import { ZIPCodeInfo } from 'types/geoService';
import { ZIP_BY_ID } from 'api/queries/geoService';
import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types/Select';

interface ZIPCodeAffiliatedData {
  state: {
    id: string;
    name: string;
  };
  counties: { id: string; name: string }[];
}

const INITIAL_DATA_OBJECT: Readonly<ZIPCodeAffiliatedData> = Object.freeze({
  state: {
    id: '',
    name: '',
  },
  counties: [],
});

/** @deprecated Use ZipCodeDelegate instead */
export class GeoStore {
  public zipCodeAffiliatedData: ZIPCodeAffiliatedData = INITIAL_DATA_OBJECT;
  wrongZipCodeKeyedIn = false;

  async requestZipCodeInfo(zipCodeId: string): Promise<void> {
    const res = await apolloClient.query<{ zipById: ZIPCodeInfo }>({
      query: ZIP_BY_ID,
      variables: { id: zipCodeId },
    });
    runInAction(() => {
      if (res.data.zipById) {
        this.zipCodeAffiliatedData = res.data.zipById;
        this.setWrongZipCodeStatus(false);
      } else {
        this.setWrongZipCodeStatus(true);
        this.resetStore();
      }
    });
  }

  setWrongZipCodeStatus(zipCodeIsWrong: boolean): void {
    this.wrongZipCodeKeyedIn = zipCodeIsWrong;
  }

  resetStore(): void {
    this.zipCodeAffiliatedData = INITIAL_DATA_OBJECT;
  }

  get countiesAsSelectOptions(): OptionType[] {
    return (
      this.zipCodeAffiliatedData?.counties.map((county) => {
        return { value: county.name, label: county.name };
      }) || []
    );
  }

  constructor() {
    makeObservable(this, {
      zipCodeAffiliatedData: observable,
      wrongZipCodeKeyedIn: observable,
      countiesAsSelectOptions: computed,
      requestZipCodeInfo: action.bound,
      setWrongZipCodeStatus: action.bound,
    });
  }
}
